import React from 'react';
import {inject, IReactComponent, observer} from 'mobx-react';
import '@techsee/techsee-ui-common/lib/collapsible-panel-animated/styles.css';
import {GalleryController, Image} from './GalleryController';
import {EmptyGalleryPlaceholder} from './EmptyGalleryPlaceholder';
import {GalleryTitle} from './GalleryTitle';
import {GalleryLoader} from './GalleryLoader';
// @ts-ignore
import failedImagePlaceholder from '../../../../../../img/failed-image-placeholder.png';

import './GalleryLive.scss';

interface GalleryLiveStoreProps {
    controller: GalleryController;
    translate: (key: string) => string;
    isCollapsible: boolean;
}

const mapImages = (image: Image) => {
    if (image.isLoading) {
        return <GalleryLoader key={image.id} id={image.id} />;
    }
    if (image.isFailed) {
        return (
            <div key={image.id} className='failed-image'>
                <img src={failedImagePlaceholder} alt='Failed image' />
            </div>
        );
    }

    return <img src={image.image} key={image.id} className='gallery-image-live' alt='Image' />;
};
@observer
class GalleryComponent extends React.Component<GalleryLiveStoreProps> {
    render() {
        const {translate, controller, isCollapsible} = this.props;
        const {isOpen} = controller;

        const images = controller.reversedImages.map(mapImages);

        return (
            <div className={`collapsible-panel gallery-collapsible ${isOpen ? 'gallery-collapsible--open' : ''}`}>
                <header className={'default-style cursor-style-pointer'} onClick={controller.toggleOpen}>
                    <GalleryTitle translate={translate} isCollapsible={isCollapsible} />
                </header>
                <div>
                    {isOpen && controller.images.length === 0 ? (
                        <EmptyGalleryPlaceholder translate={translate} />
                    ) : (
                        <div
                            className='gallery-images-scroll'
                            style={!isCollapsible ? {maxHeight: 'none', overflowY: 'visible'} : undefined}>
                            {images}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStoresToProps = (stores: any): GalleryLiveStoreProps => ({
    translate: stores.multipartyDashboardStore.localizationService.translate,
    controller: stores.multipartyDashboardStore.galleryController,
    isCollapsible: stores.multipartyDashboardStore.dashboardController.isVisualJourneyEnabled
});

export const GalleryLive = inject(mapStoresToProps)(observer(GalleryComponent)) as IReactComponent;
